import { combineReducers } from '@reduxjs/toolkit';

import { companySearch } from './company/companySearch';
import { bikeSearch } from './sell/bikeSearch';
import { carSearch } from './sell/carSearch';
import { commercialSearch } from './sell/commercialSearch';
// import { carCheckauto } from './checkauto/checkautoCar';
// import { bikeCheckauto } from './checkauto/checkautoBike';
// import { commercialCheckauto } from './checkauto/checkautoCommercial';
import { rentSearch } from './rent/rentSearch';
import { partsSearch } from './region_services/partsSearch';
import { placementSearch } from './region_services/placementSearch';
import { servicesSearch } from './region_services/servicesSearch';
import { searchData } from './searchData';

export default combineReducers({
    carSearch,
    bikeSearch,
    commercialSearch,
    companySearch,
    rentSearch,
    servicesSearch,
    placementSearch,
    partsSearch,
    searchData,
});
